"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Experiment = Experiment;
exports.experimentSelector = exports.enhance = exports["default"] = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reselect = require("reselect");

var _find = _interopRequireDefault(require("lodash/find"));

var _get = _interopRequireDefault(require("lodash/get"));

var _recompose = require("recompose");

var _reactRedux = require("react-redux");

var _experiments = require("../../modules/experiments");

var _mapDispatchToActions = _interopRequireDefault(require("../../utils/mapDispatchToActions"));

var _experiment = require("../../utils/experiment");

var experimentSelector = (0, _reselect.createSelector)(function (_ref) {
  var experiments = _ref.experiments;
  return experiments.bucket;
}, function (_ref2) {
  var experiments = _ref2.experiments;
  return experiments.forcedBucket;
}, function (bucket, forcedBucket) {
  return {
    bucket: bucket,
    forcedBucket: forcedBucket
  };
});
exports.experimentSelector = experimentSelector;
var enhance = (0, _recompose.compose)((0, _recompose.setDisplayName)('Experiment'), (0, _reactRedux.connect)(experimentSelector, {
  logImpression: _experiments.logImpression
}, _mapDispatchToActions["default"]), (0, _recompose.defaultProps)({
  logImpression: true
}), (0, _recompose.withPropsOnChange)(['bucket', 'forcedBucket', 'name'], function (_ref3) {
  var bucket = _ref3.bucket,
      forcedBucket = _ref3.forcedBucket,
      name = _ref3.name,
      _ref3$defaultVariatio = _ref3.defaultVariation,
      defaultVariation = _ref3$defaultVariatio === void 0 ? 'control' : _ref3$defaultVariatio;
  return {
    bucketedVariation: (0, _experiment.getExperimentTreatment)(name, bucket, forcedBucket, defaultVariation)
  };
}), (0, _recompose.lifecycle)({
  componentDidMount: function componentDidMount() {
    if (this.props.logImpression && (0, _experiment.isExperimentActive)(this.props.name, this.props.bucket)) {
      this.props.actions.logImpression(this.props.name);
    }
  }
}));
exports.enhance = enhance;

function Experiment(_ref4) {
  var children = _ref4.children,
      bucketedVariation = _ref4.bucketedVariation;
  return (0, _find["default"])(_react.Children.toArray(children), function (child) {
    var variation = (0, _get["default"])(child, 'props.variation', '');
    return typeof variation === 'string' ? variation === bucketedVariation : variation.includes(bucketedVariation);
  }) || null;
}

Experiment.propTypes = {
  name: _propTypes["default"].string.isRequired,
  bucketedVariation: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].node
};

var _default = enhance(Experiment);

exports["default"] = _default;